<template>
  <div class="iot-device-analysis">
    <div class="iot-stats">
      <div class="stat-row">
        <span class="stat-label">{{ $t('近三日上报率') }}</span>
        <div class="stat-value-group">
          <span class="ds-digital-bold font-18">{{ upPercent.threeUpPercent }}</span>
          <span class="unit">%</span>
        </div>
        <span class="stat-label" style="margin-left: 15px">{{ $t('开阀') }}</span>
        <div class="stat-value-group">
          <span class="ds-digital-bold font-18">{{ fkStatusTotal.meterValveOpenCount }}</span>
          <span class="unit">{{ $t('个') }}</span>
        </div>
      </div>
      <div class="stat-row">
        <span class="stat-label">{{ $t('近七日上报率') }}</span>
        <div class="stat-value-group">
          <span class="ds-digital-bold font-18">{{ upPercent.sevenUpPercent }}</span>
          <span class="unit">%</span>
        </div>
        <span class="stat-label" style="margin-left: 15px">{{ $t('关阀') }}</span>
        <div class="stat-value-group">
          <span class="ds-digital-bold font-18">{{ fkStatusTotal.meterValveCloseCount }}</span>
          <span class="unit">{{ $t('个') }}</span>
        </div>
      </div>
    </div>
    <div class="chart-container">
      <Echart ref="option" :options="option" style="height: 100%" />
    </div>
  </div>
</template>

<script>
import { putAction } from '@/api/manage'

export default {
  name: 'IotDeviceAnalysis',
  data() {
    return {
      option: {},
      upPercent: {
        threeUpPercent: 100,
        sevenUpPercent: 100
      },
      fkStatusTotal: {
        meterValveOpenCount: 0,
        meterValveCloseCount: 0
      },
      url: {
        list: '/jeecg-charge/meter/waterAnalysis/meterReportingRate',
        meterFaultCount: '/jeecg-charge/meter/waterAnalysis/meterFaultCount'
      },
      meterFault: {
        meterFaultDetail: [
          { value: 0, name: '欠压' },
          { value: 0, name: '磁干扰' },
          { value: 0, name: '阀门故障' }
        ],
        meterTotalCount: 0,
        meterFaultPercent: 0
      },
      intervalId: null,
      angle: 0
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.resetData()
        this.queryDeviceAnasis()
        this.queryMeterFaultCount()
      })
    },
    
    resetData() {
      this.option = this.$options.data.call(this).option
      this.upPercent = this.$options.data.call(this).upPercent
      this.fkStatusTotal = this.$options.data.call(this).fkStatusTotal
      this.meterFault = this.$options.data.call(this).meterFault
      this.angle = this.$options.data.call(this).angle
      
      if (this.intervalId !== null) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    },
    
    queryDeviceAnasis() {
      putAction(this.url.list, {}).then((res) => {
        if (res.success) {
          this.fkStatusTotal.meterValveOpenCount = res.result.meterValveOpenCount
          this.fkStatusTotal.meterValveCloseCount = res.result.meterValveCloseCount
          if (res.result.meterTotalCount > 0) {
            this.upPercent.threeUpPercent = Number(((res.result.lastThreeDayMeterReportCount / res.result.meterTotalCount) * 100).toFixed(0))
            this.upPercent.sevenUpPercent = Number(((res.result.lastSevenDayMeterReportCount / res.result.meterTotalCount) * 100).toFixed(0))
          }
        }
      })
    },
    
    queryMeterFaultCount() {
      putAction(this.url.meterFaultCount, {}).then((res) => {
        if (res.success) {
          this.meterFault.meterTotalCount = res.result.meterTotalCount
          this.meterFault.meterFaultDetail[0].value = res.result.meterBatteryFaultCount
          this.meterFault.meterFaultDetail[1].value = res.result.meterMagicFaultCount
          this.meterFault.meterFaultDetail[2].value = res.result.meterValveFaultCount
          this.meterFault.meterFaultPercent = Number(((res.result.meterFaultCount / res.result.meterTotalCount) * 100).toFixed(0))
          this.setOption()
          this.setIntervalId()
        }
      })
    },
    
    setIntervalId() {
      setTimeout(() => {
        this.intervalId = setInterval(() => {
          this.angle = this.angle + 5
          this.setOption()
        }, 100)
      }, 1000)
    },
    
    setOption() {
      const angle = this.angle
      const unitCount = this.$t('个')
      const data = this.meterFault.meterFaultDetail
      const total = this.meterFault.meterTotalCount
      const meterFaultPercent = this.meterFault.meterFaultPercent
      const color = [
        { start: '#FAD961', end: '#F76B1C' },
        { start: '#00D2FF', end: '#3A7BD5' },
        { start: '#60E0B2', end: '#1DCC8C' }
      ]
      
      const seriesData = []
      const innerSeriesData = []
      
      for (let i = 0; i < data.length; i++) {
        innerSeriesData.push({
          value: 12,
          name: '',
          itemStyle: {
            borderWidth: 5
          }
        }, {
          value: 2,
          name: '',
          itemStyle: {
            color: 'rgba(0, 0, 0, 0)',
            borderColor: 'rgba(0, 0, 0, 0)',
            borderWidth: 0
          }
        })
        
        seriesData.push({
          name: this.$t(data[i].name),
          value: data[i].value,
          itemStyle: {
            borderWidth: 5,
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: color[i].start },
                { offset: 1, color: color[i].end }
              ]
            },
            borderColor: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: color[i].start },
                { offset: 1, color: color[i].end }
              ]
            }
          }
        })
      }
      
      this.option = {
        color: ['#F76B1C', '#0067FF', '#1DCC8C'],
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(4, 22, 44, 0.8)',
          borderColor: 'rgba(0, 168, 255, 0.5)',
          borderWidth: 1,
          borderRadius: 4,
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        title: {
          text: `{total|${total}}{unit|${unitCount}} {total|${meterFaultPercent}}{unit|%}`,
          textStyle: {
            color: '#52C4DF',
            rich: {
              total: {
                color: '#52C4DF',
                fontWeight: 500,
                fontSize: 24
              },
              unit: {
                color: '#2A6BAC',
                fontSize: 12
              }
            }
          },
          left: 'center',
          top: 'center',
          subtext: this.$t('总计/故障率'),
          subtextStyle: {
            color: '#fff',
            verticalAlign: 'middle',
            lineHeight: 12
          }
        },
        series: [
          {
            name: 'ring5',
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: (params, api) => {
              return {
                type: 'arc',
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                  startAngle: (0 + angle) * Math.PI / 180,
                  endAngle: (90 + angle) * Math.PI / 180
                },
                style: {
                  stroke: '#00A2F3',
                  opacity: 0.5,
                  fill: 'transparent',
                  lineWidth: 2
                },
                silent: true
              }
            },
            data: [0]
          },
          {
            name: 'ring5',
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: (params, api) => {
              return {
                type: 'arc',
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                  startAngle: (120 + angle) * Math.PI / 180,
                  endAngle: (210 + angle) * Math.PI / 180
                },
                style: {
                  stroke: '#00A2F3',
                  opacity: 0.5,
                  fill: 'transparent',
                  lineWidth: 2
                },
                silent: true
              }
            },
            data: [0]
          },
          {
            name: 'ring5',
            type: 'custom',
            coordinateSystem: 'none',
            renderItem: (params, api) => {
              return {
                type: 'arc',
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                  startAngle: (240 + angle) * Math.PI / 180,
                  endAngle: (330 + angle) * Math.PI / 180
                },
                style: {
                  stroke: '#00A2F3',
                  opacity: 0.5,
                  fill: 'transparent',
                  lineWidth: 2
                },
                silent: true
              }
            },
            data: [0]
          },
          {
            name: '',
            type: 'pie',
            radius: ['50%', '55%'],
            center: ['50%', '50%'],
            animationDelay: 100,
            animationDuration: 2000,
            label: {
              show: true,
              position: 'outer',
              padding: [2, -2, 2, -2],
              borderRadius: 2,
              distanceToLabelLine: 0,
              formatter: (params) => {
                const percent = total === 0 ? 100 : ((params.value / total) * 100).toFixed(0)
                return [`{topnumber${params.dataIndex}|${params.value}}{top${params.dataIndex}|${unitCount}}{topnumber${params.dataIndex}|${percent}}{top${params.dataIndex}|%}\n{bottom${params.dataIndex}|${params.name}}`, `{hr${params.dataIndex}|}`].join('\n')
              },
              align: 'center',
              rich: this.setRichText(color)
            },
            labelLine: {
              smooth: 0.2,
              length: 15,
              length2: 45
            },
            data: seriesData
          }
        ]
      }
    },
    
    setRichText(colorList) {
      const richList = {}
      for (let i = 0; i < colorList.length; i++) {
        richList[`top${i}`] = {
          color: colorList[i].start,
          verticalAlign: 'bottom',
          padding: [5, 0, 0, 0],
          align: 'center'
        }
        richList[`topnumber${i}`] = {
          color: colorList[i].start,
          verticalAlign: 'bottom',
          padding: [5, 0, 0, 0],
          fontSize: 20,
          align: 'center'
        }
        richList[`bottom${i}`] = {
          color: colorList[i].start,
          verticalAlign: 'top',
          padding: [0, 0, 5, 0],
          align: 'center'
        }
        richList[`hr${i}`] = {
          backgroundColor: colorList[i].start,
          borderRadius: 3,
          width: 3,
          height: 3,
          align: 'center',
          padding: [3, 3, 0, -12]
        }
      }
      return richList
    }
  },
  beforeDestroy() {
    this.angle = 0
    if (this.intervalId != null) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }
}
</script>

<style lang="less" scoped>
.iot-device-analysis {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.iot-stats {
  margin-bottom: 8px;
  padding: 6px 8px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.stat-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.stat-label {
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  white-space: nowrap;
}

.stat-value-group {
  display: flex;
  align-items: center;
  gap: 2px;
}

.font-18 {
  font-size: 18px !important;
  font-weight: bold;
  color: #52C4DF;
  font-family: ds-digital-bold;
}

.unit {
  color: #2A6BAC;
  font-size: 11px;
}

.chart-container {
  flex: 1;
  min-height: 0;
}

@media (max-width: 1200px) {
  .iot-device-analysis {
    padding: 0;
  }
  
  .iot-stats {
    flex-direction: column;
    gap: 10px;
  }
  
  .stat-item {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
}
</style>